import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';

type State = { isOpen: boolean };

const initialState: State = {
  isOpen: false,
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.priceEventHistory',
  initialState,
  reducers: {
    SET_IS_OPEN: (state, action: PayloadAction<State['isOpen']>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { SET_IS_OPEN } = slice.actions;

export default slice.reducer;

export const selectorPriceEventHistory = (state: RootState) => {
  return state.ipa.priceManager.modals.priceEventHistory;
};
